<template>
  <v-container>
    <v-tabs v-model="tab" vertical>
      <v-tab key="General">{{$t('general')}}</v-tab>
      <v-tab key="fields">{{$t('entities.action.props.fields')}}</v-tab>
      <v-tabs-slider></v-tabs-slider>
      <v-tabs-items v-model="tab">
        <v-tab-item key="General">
          <v-form ref="form" v-model="valid">
            <v-text-field
              :label="$t('entities.action.props.code')"
              v-model="value.code"
              clearable
              :rules="$isRequiredRule"
            ></v-text-field>
            <v-select
              :items="$actionType"
              v-model="value.type"
              :rules="$isRequiredRule"
              :label="$t('entities.action.props.type')"
            ></v-select>
            <v-select
              v-if="value.type == 'Information'"
              :items="$entityName"
              v-model="value.entity"
              item-text="value"
              item-value="value"
              :label="$t('entities.action.props.entity')"
              clearable
            ></v-select>
            <v-text-field
              :label="$t('entities.action.props.group')"
              v-model="value.group"
              clearable
            ></v-text-field>
            <v-select
              :items="$actionResponse"
              v-model="value.response"
              :rules="$isRequiredRule"
              :label="$t('entities.action.props.response')"
            ></v-select>
            <v-text-field
              :label="$t('entities.action.props.description')"
              v-model="value.description"
              clearable
              :rules="$isRequiredRule"
            ></v-text-field>
            <v-text-field
              :label="$t('entities.action.props.path')"
              v-model="value.path"
              clearable
              :rules="$isRequiredRule"
            ></v-text-field>
          </v-form>
        </v-tab-item>
        <v-tab-item key="fields" eager>
          <action-field-tab-list v-model="value.fields"></action-field-tab-list>
          <!-- <entity-field-custom-autoform v-model="value" entity="Account"></entity-field-custom-autoform> -->
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </v-container>
</template>

<script>

import formValidationMixin from '../../../mixins/formValidationMixin'
import actionFieldTabList from './actionFieldsTabList'
export default {
  props:['value'],
  mixins:[formValidationMixin],
  components:{actionFieldTabList},
    data(){
      return{
        tab:null,
        valid:false,
      }
    }
}
</script>